module.exports = __webpack_public_path__ + "assets/favicons/britecore_logo.svg";